module.exports = __webpack_public_path__ + "static/media/deposit.39b61193.gif";